import Pace from 'pace-js/pace'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
// import Vuebar from 'vuebar'
import ViewUI from 'view-design'
import Chart from 'chart.js'
import moment from 'moment'

import './assets/styles/theme.less'

import App from './App'
import router from './router'
import store from './store'

// ViewUI ui locales
import localeUIen from 'view-design/dist/locale/en-US'
import localeUIfr from 'view-design/dist/locale/fr-FR'
// custom app locales
import localeEn from './locales/en'
import localeFr from './locales/fr'
// moment locales
import 'moment/locale/en-gb'
import 'moment/locale/fr'
import 'moment/locale/es'
import 'moment/locale/de'
import 'moment/locale/it'
// translate mixin
import translate from './mixins/translate'

// string manipulations
import numbers from './mixins/numbers'
import strings from './mixins/strings'
import server from './mixins/server'

// API base url & interceptors to inject token in headers
import { api } from './config'
import axiosInterceptors from './helpers/interceptors'
axiosInterceptors()

Vue.config.productionTip = false

// Pace activity bar
Pace.start()

// Default chartjs config
Chart.defaults.global.defaultFontColor = '#000000'
Chart.defaults.global.defaultFontFamily = 'Arial'

// Vue plugins
Vue.use(VueAxios, axios)
Vue.use(VueI18n)
// Vue.use(Vuebar)
Vue.use(ViewUI)
Vue.mixin(translate)
Vue.mixin(numbers)
Vue.mixin(strings)
Vue.mixin(server)

// vue-axios config
Vue.axios.defaults.baseURL = api.root
// Vue.axios.defaults.validateStatus = () => { return status == 200 }
Vue.axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// I18n locales and config
Vue.locale = () => { }
const savedlocale = store.getters.lang
const messages = {
	fr: Object.assign({ app: localeFr }, localeUIfr),
	en: Object.assign({ app: localeEn }, localeUIen)
}
const i18n = new VueI18n({
	locale: savedlocale,
	messages
})
ViewUI.i18n((key, value) => i18n.t(key, value))
if (savedlocale === 'en') moment.locale('en-gb')
else moment.locale(savedlocale)

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	i18n,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js